import { FC, ReactNode } from 'react';
import { Button } from './button';

interface DrawerProps {
    isOpen: boolean;
    onClose: () => void;
    drawerContent: ReactNode;
}

export const Drawer: FC<DrawerProps> = ({ isOpen, onClose, drawerContent }) => {
    return (
        <div className="drawer drawer-end">
            <div
                className={`fixed inset-0 z-40 transition-all duration-500 
                    ${isOpen
                        ? 'opacity-100 visible'
                        : 'opacity-0 invisible'
                    }
                    `}
            >
                <div
                    className={`absolute inset-0 bg-black transition-opacity duration-500 
                        ${isOpen
                            ? 'opacity-50'
                            : 'opacity-0'
                        }`
                    }
                    onClick={onClose}
                />

                <div
                    className={`absolute right-0 top-0 bg-white 
                        text-base-content min-h-full w-80 p-4 z-50
                    border-l-8 border-secondary rounded-tl-lg rounded-bl-lg shadow-lg
                    transform transition-transform duration-500 
                    ${isOpen
                            ? 'translate-x-0'
                            : 'translate-x-full'
                        }
                    `}
                    style={{ borderLeftWidth: '16px', maxHeight: 'calc(100vh - 2rem)' }}
                >
                    <Button
                        className="btn btn-secondary mb-4"
                        onClick={onClose}
                    >
                        Fermer
                    </Button>
                    {drawerContent}
                </div>
            </div>
        </div>


    );
};
